"use strict";

var _interopRequireDefault = require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _order = require("@/api/order");
var _user = require("@/api/iot/user");
var _imageViewer = _interopRequireDefault(require("element-ui/packages/image/src/image-viewer"));
var _cropUpload = _interopRequireDefault(require("@/components/cropUpload"));
var _default = {
  components: {
    ElImageViewer: _imageViewer.default,
    cropUpload: _cropUpload.default
  },
  props: ['editItem'],
  data: function data() {
    return {
      dialogVisible: false,
      isShow: false,
      image: [],
      idcard_back: '',
      idcard_front: ''
    };
  },
  watch: {
    dialogVisible: function dialogVisible(val) {
      if (val) {
        this.idcard_back = this.editItem.idcard_back;
        this.idcard_front = this.editItem.idcard_front;
      } else {
        this.idcard_back = '';
        this.idcard_front = '';
      }
    }
  },
  methods: {
    showImg: function showImg(img) {
      this.image = [this.$globalObj.imgBaseUrl + img];
      // console.log('showImg', this.image)
      this.isShow = true;
    },
    // 关闭预览
    close: function close() {
      this.isShow = false;
      this.image = [];
    },
    imgChange: function imgChange(val, type) {
      var _this = this;
      if (val) {
        var param = {
          uid: this.editItem.uid
        };
        param[type] = val;
        (0, _order.editMemberInfo)(param).then(function (res) {
          _this[type] = val;
          _this.$emit('getList', true);
        });
      } else {
        this[type] = val;
      }
    },
    auditUser: function () {
      var _auditUser = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var _this2 = this;
        var isPass,
          str,
          _args = arguments;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                isPass = _args.length > 0 && _args[0] !== undefined ? _args[0] : false;
                console.log('auditUser', isPass);
                str = isPass ? '通过审核' : '拒绝审核';
                this.$confirm("\u60A8\u786E\u5B9A\u8981 ".concat(str, " \u5417\uFF1F"), str, {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消'
                }).then(function (res) {
                  var param = {
                    id: _this2.editItem.uid,
                    is_cert: isPass ? 2 : 0
                  };
                  (0, _user.editUserInfo)({
                    form_data: param
                  }).then(function (res) {
                    _this2.$emit('getList', true);
                    _this2.dialogVisible = false;
                  });
                }).catch(function () {});
              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function auditUser() {
        return _auditUser.apply(this, arguments);
      }
      return auditUser;
    }()
  }
};
exports.default = _default;